export default __webpack_public_path__ + "static/media/reading.fbd60170.png";